import { Workbox } from 'workbox-window'
import store from '@/js/store'

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
	const wb = new Workbox(`${process.env.BASE_URL}service-worker.js`)
	const updateChannel = new BroadcastChannel('sw-updates')
	let hasWaitingUpdate = false

	wb.addEventListener('installed', (event) => {
		if (event.isUpdate) {
			store.commit('waitingToApplyUpdate', true)
			hasWaitingUpdate = true
			store.commit('updateJustInstalled', true)

			console.info(
				'✨ An app update is available now; please refresh the page.',
			)
		}
	})

	wb.addEventListener('controlling', () => {
		if (hasWaitingUpdate) {
			hasWaitingUpdate = false

			// Reload background tabs to apply the update; keep active tab unchanged.
			if (document.visibilityState === 'hidden') {
				window.location.reload()
			}
		}
	})

	// Listen for update notifications from other tabs.
	updateChannel.addEventListener('message', (event) => {
		if (event.data.type === 'activate-update') {
			// Another tab is applying the update, skip waiting so this tab activates the new SW.
			hasWaitingUpdate = true

			store.commit('waitingToApplyUpdate', true)
			wb.messageSkipWaiting()
		}
	})

	wb.register()

	// Check for updates every 8 hours, minus 1 millisecond to avoid potential timing issues with useServiceWorkerUpdates.js.
	setInterval(() => {
		if (!store.state.appUpdateCheckingIsPaused) {
			wb.update()
		}
	}, 1000 * 60 * 60 * 8 - 1)
}
